import { render, staticRenderFns } from "./PackingSelection.vue?vue&type=template&id=d70338a6&"
import script from "./PackingSelection.vue?vue&type=script&lang=js&"
export * from "./PackingSelection.vue?vue&type=script&lang=js&"
import style0 from "./PackingSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports